import React from "react";
import { Link } from "react-router-dom";
import ResourceNavigator from "./ResourceNavigator";
import ImpactStrip from "./ImpactStrip";

/*
 * Action tiles + resource navigator + impact strip, in the style of
 * proven digital-inclusion nonprofits (Compudopt / Human-I-T).
 */

const tiles = [
  {
    icon: "🛠️",
    title: "Need tech help?",
    text: "Free, patient IT guidance for anyone the digital age overwhelms.",
    cta: "Get help",
    to: "/membership",
    accent: "#12bfbe",
  },
  {
    icon: "🦈",
    title: "Meet LAMNA",
    text: "Our AI assistant — preview build live now for members.",
    cta: "Start chatting",
    to: "/it",
    memberOnly: true,
    accent: "#9198e5",
  },
  {
    icon: "💙",
    title: "Want to fuel the mission?",
    text: "Donations keep every service free for everyone who needs them.",
    cta: "Donate",
    to: "/contact",
    accent: "#1e3a8a",
  },
  {
    icon: "🤝",
    title: "Want to volunteer?",
    text: "IT skills and the heart to help? We'd love to hear from you.",
    cta: "Get involved",
    to: "/contact",
    accent: "#36395a",
  },
];

const ActionTiles = () => (
  <div className="mx-4 max-w-6xl mx-auto">
    <div className="text-center mb-8" data-aos="fade-up">
      <h2 className="text-3xl font-extrabold text-blue-900">
        How Can We Help You Today?
      </h2>
    </div>
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {tiles.map((t) => (
        <div
          key={t.title}
          className="bg-white rounded-2xl p-6 shadow-lg border-t-4 flex flex-col text-center"
          style={{ borderTopColor: t.accent }}
          data-aos="zoom-in"
        >
          <span className="text-4xl mb-3">{t.icon}</span>
          <h3 className="font-extrabold text-blue-900 mb-2">{t.title}</h3>
          <p className="text-gray-600 text-sm leading-relaxed flex-1">{t.text}</p>
          <Link
            to={t.to}
            className="mt-4 inline-block px-4 py-2 rounded-xl bg-blue-900 text-white text-sm font-bold hover:bg-blue-800 transition"
          >
            {t.cta}
          </Link>
        </div>
      ))}
    </div>
  </div>
);

const GrowthSection = () => (
  <div className="mx-4 max-w-6xl mx-auto">
    <div
      className="rounded-3xl p-8 md:p-10 text-white shadow-2xl grid md:grid-cols-2 gap-8 items-center"
      style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #36395a 100%)" }}
      data-aos="fade-up"
    >
      <div>
        <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-teal-400 text-blue-900 mb-3">
          FOR BUSINESSES &amp; CREATORS
        </span>
        <h2 className="text-3xl font-extrabold mb-3">
          ZelTechnology Digital Growth
        </h2>
        <p className="text-gray-300 leading-relaxed">
          SEO audits, content strategy, and ad-platform onboarding (Google
          AdSense, Mediavine, Ezoic) — from the team that prepped this very
          website. Modest prices for businesses, free for fellow nonprofits.
        </p>
      </div>
      <div className="text-center md:text-right">
        <Link
          to="/digital-growth"
          className="inline-block px-6 py-3 rounded-xl bg-teal-400 text-blue-900 font-extrabold hover:bg-teal-300 transition shadow-lg"
        >
          Explore Digital Growth →
        </Link>
      </div>
    </div>
  </div>
);

export { ActionTiles, GrowthSection };
